import React, { useState } from 'react';
import './button.css';

interface IButtonProps {
  text: string;
  onClick: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void>;
  disabled?: boolean; 
  className?: string;
}

function Button(props: IButtonProps) {
  const { text, onClick, disabled, className } = props;
  const [isLoading, setIsLoading] = useState(false);
  const styles = [
    'button',
    className ?? '',
  ].join(' ');

  const handleClick = async (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setIsLoading(true);
    await onClick(event);
    setIsLoading(false);
  }

  return (
    <button className={styles} onClick={ handleClick } disabled={ disabled || isLoading }>
      { isLoading ? 'секундочку' : text }
    </button>
  );
}

export default Button;
